module.exports = __webpack_public_path__ + "static/email-428014fe7b52e9ec598ffa9aee3e17e3.png";